import { backgroundTransitionOnClick, Button } from '@byecode/ui'
import styled from 'styled-components'

export const ExtraButton = styled(Button)`
    white-space: nowrap;
`

export const ActionList = styled.div`
    width: 240px;
`

export const ActionItem = styled.div`
    display: flex;
    align-items: center;
    padding: 6px 8px 6px 12px;
    font-size: var(--font-size-normal);
    cursor: pointer;
    ${backgroundTransitionOnClick}
`
